import { FC, useEffect } from 'react';

import { useTranslate } from '@growtherapy/i18n';
import { useRebrand } from '@growtherapy/sprout-ui';

import {
  BackgroundAnimationOverlay,
  Navbar,
  PageContainer,
  PageProviders,
  PushDrawerContainer,
  StageContainer,
} from '../../components';
import { setDefaultTitle } from '../../metadata';
import { Theme } from '../../state';
import { PushDrawerWrapper as PushDrawer } from '../PushDrawerWrapper';
import { INTRO_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID } from '../constants';

interface PageProps {
  pageContentComponent: FC;
}

export function Page({ pageContentComponent: PageContentComponent }: PageProps) {
  const t = useTranslate();
  const isRebrand = useRebrand();

  useEffect(
    function setDefaultPageTitle() {
      setDefaultTitle(t);
    },
    [t],
  );

  return (
    <>
      <PageProviders theme={Theme.LIGHT}>
        <PageContainer>
          {!isRebrand && <BackgroundAnimationOverlay autoplay={false} />}
          <div className='relative flex flex-col h-full w-full'>
            <Navbar showLanguageSwitcher />
            <PushDrawerContainer>
              <StageContainer className='bg-transparent overflow-auto justify-normal'>
                <PageContentComponent />
              </StageContainer>
              <PushDrawer className='sm:my-2 sm:h-auto' id={INTRO_ROOM_PUSH_DRAWER_ARIA_CONTROLS_ID} />
            </PushDrawerContainer>
          </div>
        </PageContainer>
      </PageProviders>
    </>
  );
}
